import { render } from "./NewCard.vue?vue&type=template&id=bdbf73f8&scoped=true"
import script from "./NewCard.vue?vue&type=script&lang=js"
export * from "./NewCard.vue?vue&type=script&lang=js"

import "./NewCard.vue?vue&type=style&index=0&id=bdbf73f8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdbf73f8"]])

export default __exports__